import http from "../../utils/http";

// 매니저 - 담당자 상담 리스트
export const getManagerCounselingList = (type, managerIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/counseling/manager/${type}/list/${managerIdx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};